import React/*, {useEffect, useState}*/ from "react"
import "./communityabout2021.css"


const CommunityAbout = ( ) => {




    return (
        <section className="communityabout2021" id="CommunityEvents">
            <div className="containfix">
                    <div>
                        <h1 className="communityabout2021">COMMUNITY EVENTS</h1>
                        <p className="underabout2021">Community events are the heart and soul of AI Week! Join 10,000 top C-suite leaders, decision makers, and influencers from the government, tech and education communities across the nation and participate in interactive sessions, talks, and networking opportunities to get an exclusive look at the latest in artificial intelligence.

<br /><br />Once you get your free AI Week pass, you will get access to all of the AI Week events. Make sure to sign up for as many events as you can and get the most out of AI Week!





                        </p>


                    </div>

            </div>

        </section>

    )
}

export default CommunityAbout
